import UploadCSV from './teams/csv/UploadCSV'
import Tools from './admin/Tools'
import GroupDashboardContent from './pages/groups-dashboard/GroupDashboardContent'
import GroupLinkUnlink from './teams/group/GroupLinkUnlink'

/**
 * Add components to render here with its respective classes.
 * component: The component to use inside your class
 * selector: The name of the class that you need your component to render
 * data (optional): Data from HTML attribute 
 */
export const componentsData = () => {
    return [
        {
            component: Tools,
            selector: '.msync-settings-tools',
        },
        {
          component: GroupDashboardContent, // component to use
          selector: '.membersync-group-dashboard-content', // class name,
          data: [
            'data-organizations',
            'data-team-options',
            'data-site-options',
            'data-site-filters',
          ]
        },
        {
            component: UploadCSV,
            selector: '.msync-upload-csv-modal', 
            data: [
              'data-team',
              'data-modal-classnames'
            ]
        },
        {
            component: GroupLinkUnlink,
            selector: '.msync-teams-group-link-unlink', 
            data: [
                'data-group',
            ]
        },
    ]
}
